import React from 'react';

import theme, { StylableComponent } from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';

const Placeholder = ({
  children,
  style,
  ...props
}: StylableComponent<HTMLDivElement>) => {
  const { t } = useTranslation();
  const placeholder = children || t('SELECT');

  return (
    <div
      css={[
        theme.typography.labelMedium,
        theme.typography.ellipsis,
        {
          color: theme.tokens.colors.text.tertiary.value,
          pointerEvents: 'none',
          userSelect: 'none',
          flex: 1,
        },
        style,
      ]}
      {...props}
    >
      {placeholder}
    </div>
  );
};

export default Placeholder;
